var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{key:_vm.venueModel,staticClass:"page page-place-revision"},[(_vm.venueModel.uniqueKey)?_c('ViewVenueDetailForm',{attrs:{"venueModel":_vm.venueModel},on:{"submit":_vm.Handle_OnSubmitRevision}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }